const state = {
	tenant: null
}

const getters = {
	get: state => {
		return state.tenant
	}
}

const mutations = {
	set: (state, tenant) => {
		localStorage.setItem('tenant', JSON.stringify(tenant))
		state.tenant = tenant
	},
	setState: (state, tenant) => {
		state.tenant = tenant
	}
}

const actions = {
	init: (context) => {
		context.commit('setState', localStorage.getItem('tenant') ? JSON.parse(localStorage.getItem('tenant')) : null)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tenant.js